module.exports = __webpack_public_path__ + "static/media/standard.2fb3b68f.svg";